import { render, staticRenderFns } from "./ExtendedCompass.vue?vue&type=template&id=9b6b3532&scoped=true&"
import script from "./ExtendedCompass.vue?vue&type=script&lang=ts&"
export * from "./ExtendedCompass.vue?vue&type=script&lang=ts&"
import style0 from "./ExtendedCompass.vue?vue&type=style&index=0&id=9b6b3532&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6b3532",
  null
  
)

export default component.exports